<template>
  <v-dialog
      v-model="show"
      width="800"
    >
      <v-card >
        <v-card-title>Configuration File Changes</v-card-title>

        <v-data-table 
          :headers="headers"
          :items="mappedChanges"
        />

        <v-card-actions>
          <div v-if="partialWithNoChanges" class="error-message">You have selected to send only changes, but no changes have been made. Please make one or more changes before creating this job.</div>
          <v-spacer/>
          <v-btn text color="red" @click="cancelUpdate">
            cancel
          </v-btn>

          <v-btn text color="green" :disabled="partialWithNoChanges" @click="submitUpdate">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

var get = require('lodash.get');

import { Logger } from "aws-amplify";
const logger = new Logger("Review Changes");

export default {
  name: 'ReviewChanges',
  props: {
    changes: {
      type: Array,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    context: {
      type: String,
      required: true
    },
    configType: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Setting',
          value: 'label'
        },
        {
          text: 'Previous',
          value: 'previous'
        },
        {
          text: 'Current',
          value: 'current'
        }
      ],
      speedMap: {
        0: 0,
        16: 10,
        24: 15,
        32: 20,
        40: 25,
        48: 30,
        56: 35
      }
    }
  },
  computed: {
    mappedChanges() {
      const updatedToMph = this.changes.find(change => change.newValue == 'mph');
      let mappedItems = this.changes.map(item => {
        logger.info('change here ', item)
        let isAlert = item.key.includes('device_config.cv[0].dms[0].alerts[0]');

        return {
          label: item.label,
          previous: this.mapInitValue(item, true),
          current: isAlert && updatedToMph ? this.speedMap[item.newValue] : this.mapInitValue(item),
          key: item.key
        }
      });
      logger.info('mappedItems init', mappedItems)
      mappedItems = mappedItems.filter(change => change.key != "device_config.target[0].model[0]" && change.key != 'device_config.version[0]' && change.current != 'removePropertyFromConfigObject');
      logger.info('mappedItems debug ', mappedItems)
      return mappedItems
    },
    partialWithNoChanges() {
      if (this.configType == 'partial' && this.changes.length <= 2) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    mapInitValue(item, isInit = false) {
      const map = item.map;
      const key = item.key;
      let value = '';

      if (isInit) {
        value = get(this.config, key);
      } else {
        value = item.newValue;
      }
      logger.info('value ', value)
      const mappedInitVal = map.find(prop => prop.xml == value);
      logger.info('mappedInitVal ', mappedInitVal)
      return mappedInitVal ? mappedInitVal.label : value;
    },  
    cancelUpdate() {
      this.$emit('close');
    },
    submitUpdate() {
      this.$emit(this.context);
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-message {
    color: #F44336;
  }
</style>